import { Component, OnInit, ViewChild } from '@angular/core';
import { LoginService } from 'src/app/components/Shared/Service/login_service';
import { RateSyncChannelService } from 'src/app/components/Shared/Service/rate-sync-channel.service';

import { MomentDateAdapter, MAT_MOMENT_DATE_ADAPTER_OPTIONS } from '@angular/material-moment-adapter';
import { DateAdapter, MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { DatePipe } from '@angular/common';
import {ToastrService} from 'ngx-toastr'
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { MatSelectChange, MatTableDataSource } from '@angular/material';
import { IdsProductsService } from '../Shared/Service/ids-products.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { DashboarduiService } from '../Shared/Service/dashboardui.service';
import { interval } from 'rxjs';

export const MY_FORMATS = {
  parse: {
    dateInput: 'LL',
  },
  display: {
    dateInput: 'LL',
    monthYearLabel: 'MMM YYYY',
    dateA11yLabel: 'LL',
    monthYearA11yLabel: 'MMMM YYYY',
  },
};

export class idsProductList {
    id: number;
    status: String;
    hotelName: String;
    accountingDate: any;
    pusheddate: any;
    type:any
}
@Component({
  selector: 'app-bwcrm',
  templateUrl: './bwcrm.component.html',
  styleUrls: ['./bwcrm.component.css','../commonStyle.css'],
  providers: [LoginService, IdsProductsService,RateSyncChannelService,
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE, MAT_MOMENT_DATE_ADAPTER_OPTIONS]
    },

    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ]
})
export class BWCRMComponent implements OnInit {
  searchText:any;
  typ:any;
  public PGF: any = "0";
  public PGT: any = "50";
  pageSize = 50;
  pageSizeOptions: number[] = [5, 10, 250, 500];
  isIDSUser: any;
  apiresult: any;
  hotellistChannel: any[];
  hotellistproperty: any;
  ColumnHeader: boolean;
  url: string;
  maxDate: Date;
  errorMsgSubscription: boolean;
  errorMessage: string;
  displayContent: boolean;
  filterProperty: any;
  addBtnDisabledFunc: boolean;
  excelFunction: boolean;
  searchBarFilter: boolean;
  ValSearchDownload: string;
  hotelSearchDataStatus: any;
  productType: any;
  constructor(private apiCallIdsService: DashboarduiService,private toastr: ToastrService, private datePipe: DatePipe, public loginService: LoginService) {
    
  }
  today = new Date();
  today1:any= new Date();
  CurrentDate = new Date();
  selectedDate: any= new Date(this.today.setDate(this.today.getDate()));//remove the -1 Indhuja 24-03-2025
  selectedTOODate: any= new Date(this.today1.setDate(this.today1.getDate()));//remove the -1  Indhuja 24-03-2025
  display: Boolean = false; 
  totalcount: any = 0;
  hotellistCopy: any = [];
  public idsProductList: idsProductList[];
  // lstidsProductList: MatTableDataSource<idsProductList>;
  dataSource: MatTableDataSource<idsProductList>
  StorelstRestr: any;
  // lstidsProductList:any;
  // dataSource:any;
  @ViewChild(MatPaginator, { static: true }) paginator: MatPaginator;
  @ViewChild(MatSort, { static: true }) sort: MatSort;

  Val: string;
  selectedProperty: string;
  UID:any;
  selectedChannel: any;
  isProgressing: Boolean = false;
  public Pmscodevalue: any;
  // public LOGS: any;
  lstgetcmlist:any[];
  hotellist: any = [];
  allproperty: any[];
  selected: string;
  Userid: any = [];
  displayedColumns: string[] = ['hotelName','heartbeat', 'accountingDate','hour', 'pusheddate', 'type'];
  heartBeatData: any;
  dropdownSettingsDept: IDropdownSettings = {};
  selectedDeptItems:any;
  dropdownDeptData: any
  checkTodayDate:any
  currentDateStore: any;
  storeHeartBeatValue: any;
  blinkOfflineHotel: boolean = false;
  hideSearchFilter(){
    this.ValSearchDownload = '';
    this.searchBarFilter = false
  }
  ngOnInit() {
     this.checkTodayDate = this.CurrentDate.getDate()
    console.log('check Today =', this.checkTodayDate)
    this.isProgressing = false;
       this.callIDSUsersProperties();
      //this.loadMethod();
      this.dropdownSettingsDept = {
        idField: 'propertyCode',
        textField: 'propertyName',
        allowSearchFilter: true,
        singleSelection: true,
        enableCheckAll: false,
        closeDropDownOnSelection: true,
        itemsShowLimit: 7,
        noDataAvailablePlaceholderText: 'No Data Found',
        searchPlaceholderText: "Search Hotel Code / Name"
      };
  }

  loadMethod(){
    this.isProgressing = true
    //this.isProgressing = false;
    this.selectedDate = this.datePipe.transform(this.selectedDate, 'yyyy-MM-dd');
    this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');

    if (this.selectedTOODate < this.selectedDate) {
      this.isProgressing = false;
      this.toastr.error('From date should be less than To date.');

    }
    else {
      this.selectedTOODate = this.datePipe.transform(this.selectedTOODate, 'yyyy-MM-dd');
    }
        this.apiCallIdsService.readBWCRMReadAPIData(this.Pmscodevalue,this.selectedDate,this.selectedTOODate)
        .subscribe(
          data => {
            console.log('readBWCRMReadAPIData Data =', data)
            if(data.length >0){
              this.errorMsgSubscription = false
              this.displayContent = true
            this.idsProductList=data;
            this.filterProperty = this.idsProductList
          this.dataSource = new MatTableDataSource(this.idsProductList);
          console.log('this.dataSource =', this.dataSource)
          this.dataSource.paginator = this.paginator;
          this.toastr.success('Data Loaded Successfully');
          this.isProgressing = false;
          }else{
            this.displayContent = false
            this.errorMsgSubscription = true
            this.errorMessage = "No Data Found"
            this.toastr.error('No Data Found');
            this.isProgressing = false;
          }
          },
          );
  }

  GetHeartbeatDateTime(heartBeatData:any) {
    console.log('GetHeartbeatDateTime call',heartBeatData)
// For blinking the record
const today = new Date()
        console.log('Today Date = ',today);
        this.currentDateStore = today.toLocaleTimeString('it-IT')
        console.log('Today Date = ',this.currentDateStore);
        this.storeHeartBeatValue = this.GetHeartbeatTime(heartBeatData)
// this.storeHeartBeatValue = heartBeatData
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[0], 0);
var endDate = new Date(0, 0, 0, end[0], end[0], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
  // return heartBeatData
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
  // return heartBeatData
} 
return heartBeatData
  }

  GetHeartbeatTime(d:any) {
    console.log('GetHeartbeatTime call = ',d.substring(12))
    return (d.substring(12));
  }

  SearchHotels(event:any) {
    console.log('event= ', event)
    this.dataSource = this.filterProperty.filter((res: { hotelName: { toString: () => string; }}) => {
      return res.hotelName.toString().toLocaleLowerCase().match(this.Val.toLocaleLowerCase())
    });
    if(event == ''){
      this.Val = '';
    }
  }

/*   callIDSUsersProperties() {
    this.Userid = localStorage.getItem("Username");
    console.log(this.Userid)
    this.apiCallIdsService.getBWCRMist()
      .subscribe(
        data => {
          console.log('New Screen Data', data)
          this.apiresult = data;
            this.apiresult.unshift({
              "propertyCode": "All",
              "propertyName": "All Property"
            });

          this.dropdownDeptData = this.apiresult
        this.selectedDeptItems = this.getDimensionsByFilter("All");
        console.log('this.StoreValuetest',this.selectedDeptItems[0].propertyCode);
        this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
        console.log('this.Pmscodevalue =',this.Pmscodevalue)
          this.isProgressing=false;
        });
  } */
        callIDSUsersProperties() {
          this.isProgressing = true;
          this.apiCallIdsService.getBWCRMist()
            .subscribe(
              data => {
                console.log('New Screen Data', data)
                //Remove duplicate data
                this.apiresult = data;
                this.hotellist = this.apiresult
                this.dropdownDeptData = this.apiresult
                console.log('Property 113 = ', this.hotellist)
                this.hotellistproperty = this.hotellist;
                this.isProgressing = false;
              });
      
        }
  getDimensionsByFilter(propertyCode:any){
    console.log('dropdownDeptData =',this.dropdownDeptData)
    return this.dropdownDeptData.filter((x: { propertyCode: any; }) => x.propertyCode === propertyCode);
  }


  GetParseonlyDateTime(d:any) {
    console.log('GetParseonlyDateTime call',d)
    if (d == "") {
      return "";
    }
    console.log('GetParseonlyDateTime = ',d.substring(4, 7))
    return (d.substring(4, 7));
  }

  // GetParseonlyDateTimeHeartbeat(d:any) {
  //   console.log('GetParseonlyDateTimeHeartbeat',d)
  //   if (d == "") {
  //     return "";
  //   }
  //   console.log('GetParseonlyDateTimeHeartbeat = ',d.substring(0, 2))
  //   return (d.substring(0, 2));
  // }

  GetParseonlyDateTimeHeartbeat(d:any) {
    var dt1 = new Date(d);
    var dt2 = new Date();
    console.log('dt1 = ',dt1)
    console.log('dt2 = ',dt2)
    var diff =(dt2.getTime() - dt1.getTime()) / 1000;
    diff /= 60;
    console.log('diff alone = ',diff);
    console.log('Math ABS = ',Math.abs(Math.round(diff)));
    if(Math.abs(Math.round(diff)) > 60){
      return false
    }else{
      return true
    }
      }
  pageEvent(e) {
    console.log(e)
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  } 
  changePropertySearch() {
    // console.log('selectedDeptItems = ',this.selectedDeptItems)
    if(this.selectedDeptItems){
      this.searchBarFilter = false
    this.ValSearchDownload = '';
    if(this.selectedDeptItems.length > 0){
      this.totalcount = 0
      console.log('if condition')
      this.Pmscodevalue = this.selectedDeptItems[0].propertyCode
      console.log('pms code value = ',this.Pmscodevalue)
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.addBtnDisabledFunc = false
      // For Online Status
    this.apiCallIdsService
    .readHotelSearch(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHotelSearch =',data)
      this.hotelSearchDataStatus = data[0].recordstatus
      this.productType = data[0].producttype
    });
      this.apiCallIdsService
      .readHeartbeat(this.Pmscodevalue)
      .subscribe((data) => {
        console.log('readHeartbeat =',data[0])
        this.heartBeatData = data[0].heartBeat
        
// For blinking the record
const today = new Date()
console.log('Today Date = ',today);
this.currentDateStore = today.toLocaleTimeString('it-IT')
console.log('Today Date = ',this.currentDateStore);
this.storeHeartBeatValue = this.GetParseonlyDateTime(this.heartBeatData)
var start = this.storeHeartBeatValue.split(":");
var end = this.currentDateStore.split(":");
var startDate = new Date(0, 0, 0, start[0], start[1], 0);
var endDate = new Date(0, 0, 0, end[0], end[1], 0);
var diff = endDate.getTime() - startDate.getTime();
var hours = Math.floor(diff / 1000 / 60 / 60);
diff -= hours * 1000 * 60 * 60;
var minutes = Math.floor(diff / 1000 / 60);
// console.log('minutes difference',minutes)
console.log('minutes difference', hours + ":"  + minutes)
if((hours + ":"  + minutes) > "0:30"){
  console.log('blinkOfflineHotel true')
  this.blinkOfflineHotel = true
}else{
  console.log('blinkOfflineHotel false')
  this.blinkOfflineHotel = false
}

      });
      interval(2000 * 60).subscribe(() => {
        this.heartbeatFunction();
      });
    }else{
      console.log('Else condition zero')
      this.errorMsgSubscription = true
      this.errorMessage = "Please select property and load"
      this.displayContent = false
      this.excelFunction = false
      this.addBtnDisabledFunc = true
    }
  }else{
    console.log('Property Not Selected')
  }
  }
  heartbeatFunction(){
    this.apiCallIdsService
    .readHeartbeat(this.Pmscodevalue)
    .subscribe((data) => {
      console.log('readHeartbeat =',data[0])
      this.heartBeatData = data[0].heartBeat
    });
  }

}
